import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { Container } from "reactstrap";
import { scrollWindow } from "../../../../helpers/common";
import CandidateRow from "../../../../helpers/Common/CandidateRow";
import NotFound from "../../../../helpers/Common/NotFound";
import SmallLoader from "../../../../helpers/Common/SmallLoader";
import Section from "./Section";
import { getBookmarkJobs } from "../../../../actions/bookmarkCandidates";

const BookMarkCandidates = () => {
  const bookmarkCandidates = useSelector((state) => state.bookmarkCandidates);

  const candidatesList = bookmarkCandidates?.data?.data?.data || [];
  const loading = bookmarkCandidates.loading;
  console.log("candidatelists**", candidatesList);

  useEffect(() => {
    scrollWindow();
  }, []);
  console.log("Component Mounted");

  return (
    <React.Fragment>
      <Helmet>
        <title>Bookmarked Candidates | Webvi Page </title>
      </Helmet>
      <Section />

      {loading ? (
        <SmallLoader />
      ) : candidatesList?.length > 0 ? (
        <section className="section">
          <Container>
            {candidatesList?.map((details) => {
              // 🟢 FIXED: pehle sirf `candidate` object spread ho raha tha —
              // `candidateAdditionalFields` (designation, salary, skills, experience)
              // bilkul include nahi ho raha tha, isliye CandidateRow ko wo data
              // milta hi nahi tha.
              const rowDetails = {
                ...details?.candidate,
                userId: details?.candidate?.id, // 'id' (118) ko 'userId' pe map karo
                additional_fields: details?.candidateAdditionalFields, // 🟢 NEW — ye missing tha
              };

              return <CandidateRow details={rowDetails} key={details?.id} />;
            })}
          </Container>
        </section>
      ) : (
        <NotFound
          icon="ic:round-people-alt"
          message="You don't have bookmark candidates list."
        />
      )}
    </React.Fragment>
  );
};

export default BookMarkCandidates;
